export const UPDATE_RESTAURANT_REQUEST = 'UPDATE_RESTAURANT_REQUEST'
export const UPDATE_RESTAURANT_SUCCESS = 'UPDATE_RESTAURANT_SUCCESS'
export const UPDATE_RESTAURANT_ERROR = 'UPDATE_RESTAURANT_ERROR'
export const APPROVE_RESTAURANT_REQUEST = 'APPROVE_RESTAURANT_REQUEST'
export const APPROVE_RESTAURANT_SUCCESS = 'APPROVE_RESTAURANT_SUCCESS'
export const APPROVE_RESTAURANT_ERROR = 'APPROVE_RESTAURANT_ERROR'
